import { Button } from "@components/ui";
import React from "react";

const StoreViewButton = ({
  storeId,
  isMobile,
}: {
  storeId: number;
  isMobile: boolean;
}) => (
  <Button
    internalPath={`/find-a-store?store=${storeId}${
      isMobile ? "&modal=closed" : ""
    }`}
    variant="primary"
    className={`shadow-default mt-2 ${
      isMobile ? "lg:hidden" : "hidden lg:flex"
    }`}
  >
    View on Map
  </Button>
);

export default StoreViewButton;
